import React, { useCallback, useEffect, useState } from 'react';
import { Box } from 'native-base';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Mousewheel, Pagination, Keyboard } from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import {
    Stashboard,
    StashboardMedia,
    useTheme,
} from '@springbig/shared';
import { Caption } from './Typography';
import { CarouselCard } from '~/pages/message/components/MessageCarouselCard';

type CarouselProps = {
    images?: StashboardMedia[]
    stashboard?: Stashboard;
}

const Carousel = ({ images, stashboard }: CarouselProps) => {

    const {
        primary,
        button_primary,
        button_text,
    } = useTheme();

    const [snapIndex, setSnapIndex] = useState(0);
    const [imgHeights, setImgHeights] = useState([]);

    const [loadedFlags, setLoadedFlags] = useState<boolean[]>([]);

    const markAsLoaded = useCallback((index: number) => {

        setLoadedFlags((prev) => {

            const next = [...prev];
            next[index] = true;
            return next;
        });
    }, []);


    useEffect(() => {

        document.querySelector('.swiper-pagination-bullet-active')?.setAttribute('style', `background-color: ${primary} !important`);
    });

    const detailsScreen = window.location.href.includes(stashboard._key);

    return (
        <Swiper
            spaceBetween={0}
            navigation={false}
            pagination={{
                clickable: true,
                type: 'bullets'
            }}
            keyboard={true}
            modules={[Pagination, Mousewheel, Keyboard]}
            className="mySwiper"
            style={
                (detailsScreen && stashboard.type === 'mp5') ?
                    {
                        pointerEvents: 'auto',
                        width: '100%',
                        height: '100vh',
                    }
                    :
                    {
                        pointerEvents: 'auto',
                        width: '100%',
                        height: imgHeights[snapIndex] ? `${imgHeights[snapIndex]}px` : 'auto'
                    }
            }
            onSlideChange={(swiper) => {

                setSnapIndex(swiper.snapIndex);
            }}
            autoHeight={true}
        >
            { images && images.length > 0 && images.map((el, index) => (

                <SwiperSlide
                    style={{
                        width: '100%',
                    }}
                    key={'swiper' + index}
                >
                    <CarouselCard
                        index={index}
                        currentIndex={snapIndex}
                        item={el}
                        stashboard={stashboard}
                        setImgHeight={(height: number) => {

                            setImgHeights((prevHeights) => {

                                const newHeights = [...prevHeights];
                                if (height !== 0 && (newHeights[index] === undefined || newHeights[index] === 0)) {
                                    newHeights[index] = height;
                                }

                                return newHeights;
                            });
                        }}
                    />
                </SwiperSlide>
            ))}
            {
                images && images.length > 1 && (
                    <Box
                        position={'absolute'}
                        top={-30}
                        right={4}
                        mt={12}
                        px={2}
                        bg={button_primary}
                        alignItems='center'
                        justifyContent={'center'}
                        flexDirection='row'
                        borderRadius={8}
                        zIndex={1}
                    >
                        <Caption
                            color={button_text}
                            fontSize={12}
                        >
                            { snapIndex + 1 }/{ images.length }
                        </Caption>
                    </Box>
                )
            }
        </Swiper>

    );

};

export default Carousel;
